import type { JSX } from 'react';

import { Separator, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { SignFormContainer } from '../signFormSunrise';
import { SignatureStatsActiveContainer } from '../stats/signatureStats';

function SideUnsignedContainerInner(): JSX.Element {
	return (
		<>
			<Text className="my-4" variant="heading" as="h2" size="small">
				<Translate value="corgi.petition_gamma.petition_sign.sign_title" />
			</Text>
			<div className="hidden md:block">
				<SignFormContainer />
			</div>

			<div className="block md:hidden">
				<Loader size="s" mt={64} mx="auto" />
			</div>
		</>
	);
}

export function SideUnsignedContainer(): JSX.Element {
	return (
		<>
			<div className="mb-4">
				<SignatureStatsActiveContainer />
			</div>
			<Separator />
			{/* using programmatic media query to allow lazy loading of the sign form in modal on mobile */}
			{/* Spinner is necessary for SSR */}
			<ClientRender placeholder={<Loader size="s" mt={64} mx="auto" />}>
				<SideUnsignedContainerInner />
			</ClientRender>
		</>
	);
}
